<div class="page-header"><h1 class="page-title">Session History</h1></div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Agent Sessions: ' + agent.username"
			[downloadName]="'agent_sessions_' + agent.username"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[loading]="loading"
			(onUpdateRequired)="doFetchResults($event)"
			>
			<ng-template #givenNames let-row="row">
				<td>
					{{row.firstName??''}} {{row.secondName??''}} {{row.otherNames??''}}
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
